// Core packages
import { NgModule } from '@angular/core';

// Third party packages

// Custom packages - Modules
import { PublicModule } from 'src/app/modules/public/public.module';
import { SharedModule } from '../shared.module';
import { InterventionsRoutingModule } from './interventions-routing.module';

// Custom packages - Components
import { AddInterventionComponent } from 'src/app/modules/interventions/pages/add-intervention/add-intervention.page';
import { InterventionDetailComponent } from 'src/app/modules/interventions/pages/intervention-detail/intervention-detail.page';
import { InterventionsListComponent } from 'src/app/modules/interventions/pages/interventions-list/interventions-list.page';
import { AddContractorDialogComponent } from './components/add-contractor-dialog/add-contractor-dialog.component';
import { AddReceivedDocumentDialogComponent } from './components/add-receivedDocument-dialog/add-receivedDocument-dialog.component';
import { AddTaxDeductionFeeDialogComponent } from './components/add-taxDeductionFee-dialog/add-taxDeductionFee-dialog.component';
import { EditContractorDialogComponent } from './components/edit-contractor-dialog/edit-contractor-dialog.component';
import { EditReceivedDocumentDialogComponent } from './components/edit-receivedDocument-dialog/edit-receivedDocument-dialog.component';
import { EditTaxDeductionFeeDialogComponent } from './components/edit-taxDeductionFee-dialog/edit-taxDeductionFee-dialog.component';

@NgModule({
  imports: [
    // Shared modules
    SharedModule,

    // Custom
    InterventionsRoutingModule,
    PublicModule,
  ],
  declarations: [
    InterventionsListComponent,
    InterventionDetailComponent,
    AddInterventionComponent,
    AddContractorDialogComponent,
    EditContractorDialogComponent,
    AddTaxDeductionFeeDialogComponent,
    EditTaxDeductionFeeDialogComponent,
    AddReceivedDocumentDialogComponent,
    EditReceivedDocumentDialogComponent,
  ],
  entryComponents: [
    AddInterventionComponent,
    AddContractorDialogComponent,
    EditContractorDialogComponent,
    AddTaxDeductionFeeDialogComponent,
    EditTaxDeductionFeeDialogComponent,
    AddReceivedDocumentDialogComponent,
    EditReceivedDocumentDialogComponent,
  ],
  exports: [
  ]
})
export class InterventionsModule { }
